import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Review functionality for User Access Review Directory
 * @param {object[]} props.staffData list of employees reporting to logged in user
 * @returns navigation card for review
 */
const ReviewCard = ({ staffData = [], messages }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Employee Review'}
			icon={<PAGE_ICONS.REVIEW color='error' />}
			role={'Annual Review'}
			description={
				'Validate application access, service accounts, badges, and mobile devices for employees and contingency workers for the next year.'
			}
			onClick={() => history.push(PAGE_ROUTES.REVIEW)}
			messages={messages}
		/>
	) : null;
};

ReviewCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
	messages: PropTypes.arrayOf(PropTypes.object),
};

export default ReviewCard;
